/**
 * @generated SignedSource<<8e4deca1c80f059753816565e1f26309>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateGeneralTimeRegistrationSettingsInput = {
  id: string;
  allowDoneTasks?: boolean | null;
  allowProjects?: boolean | null;
  allowInternalTime?: boolean | null;
  allowBillableSplit?: boolean | null;
  allowRoles?: boolean | null;
  allowExceedingEstimate?: boolean | null;
  allowOutsideTaskDates?: boolean | null;
  allowOutsideProjectDates?: boolean | null;
  requireTaskAssignment?: boolean | null;
  requireNote?: boolean | null;
  strictMode?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type UpdateGeneralTimeRegistrationSettingsMutation$variables = {
  input: UpdateGeneralTimeRegistrationSettingsInput;
};
export type UpdateGeneralTimeRegistrationSettingsMutation$data = {
  readonly updateGeneralTimeRegistrationSettings: {
    readonly timeRegistrationSettings: {
      readonly granularity: string | null;
      readonly allowDoneTasks: boolean | null;
      readonly allowProjects: boolean | null;
      readonly allowInternalTime: boolean | null;
      readonly allowBillableSplit: boolean | null;
      readonly allowRoles: boolean | null;
      readonly allowExceedingEstimate: boolean | null;
      readonly allowOutsideProjectDates: boolean | null;
      readonly allowOutsideTaskDates: boolean | null;
      readonly requireTaskAssignment: boolean | null;
      readonly requireNote: boolean | null;
      readonly strictMode: boolean | null;
    } | null;
  } | null;
};
export type UpdateGeneralTimeRegistrationSettingsMutation$rawResponse = {
  readonly updateGeneralTimeRegistrationSettings: {
    readonly timeRegistrationSettings: {
      readonly granularity: string | null;
      readonly allowDoneTasks: boolean | null;
      readonly allowProjects: boolean | null;
      readonly allowInternalTime: boolean | null;
      readonly allowBillableSplit: boolean | null;
      readonly allowRoles: boolean | null;
      readonly allowExceedingEstimate: boolean | null;
      readonly allowOutsideProjectDates: boolean | null;
      readonly allowOutsideTaskDates: boolean | null;
      readonly requireTaskAssignment: boolean | null;
      readonly requireNote: boolean | null;
      readonly strictMode: boolean | null;
      readonly id: string;
    } | null;
  } | null;
};
export type UpdateGeneralTimeRegistrationSettingsMutation = {
  variables: UpdateGeneralTimeRegistrationSettingsMutation$variables;
  response: UpdateGeneralTimeRegistrationSettingsMutation$data;
  rawResponse: UpdateGeneralTimeRegistrationSettingsMutation$rawResponse;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "granularity",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowDoneTasks",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowProjects",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowInternalTime",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowBillableSplit",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowRoles",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowExceedingEstimate",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowOutsideProjectDates",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowOutsideTaskDates",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requireTaskAssignment",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requireNote",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "strictMode",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateGeneralTimeRegistrationSettingsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateGeneralTimeRegistrationSettingsPayload",
        "kind": "LinkedField",
        "name": "updateGeneralTimeRegistrationSettings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TimeRegistrationSettingsType",
            "kind": "LinkedField",
            "name": "timeRegistrationSettings",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateGeneralTimeRegistrationSettingsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateGeneralTimeRegistrationSettingsPayload",
        "kind": "LinkedField",
        "name": "updateGeneralTimeRegistrationSettings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TimeRegistrationSettingsType",
            "kind": "LinkedField",
            "name": "timeRegistrationSettings",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1bbdcdacf27036369e40227581046e9e",
    "id": null,
    "metadata": {},
    "name": "UpdateGeneralTimeRegistrationSettingsMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateGeneralTimeRegistrationSettingsMutation(\n  $input: UpdateGeneralTimeRegistrationSettingsInput!\n) {\n  updateGeneralTimeRegistrationSettings(input: $input) {\n    timeRegistrationSettings {\n      granularity\n      allowDoneTasks\n      allowProjects\n      allowInternalTime\n      allowBillableSplit\n      allowRoles\n      allowExceedingEstimate\n      allowOutsideProjectDates\n      allowOutsideTaskDates\n      requireTaskAssignment\n      requireNote\n      strictMode\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2e575b545702c673d11b33a7769688bc";

export default node;
